<template>
<v-container fluid class="verify-page">
    <v-row justify="center" class="py-6">
      <v-col cols="12" md="10" lg="8">
        <header-vue class="text-center mb-4"/>
        <v-card class="auth-card rounded-xl overflow-hidden" elevation="8">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="quick-links-panel pa-8 d-flex flex-column justify-center">
              <v-icon size="44" class="mb-3 white--text">mdi-email-check-outline</v-icon>
              <div class="text-overline font-weight-bold white--text">MYSCH</div>
              <div class="text-h5 font-weight-bold white--text mb-2">Verify Your Email</div>
              <div class="text-body-2 white--text recover-blurb">
                Just to be sure you're not a robot! Enter the code sent to <strong>{{email}}</strong>
              </div>
            </v-col>

            <v-col cols="12" md="8">
              <v-card-text class="pa-8 pa-md-10">
                <div class="text-overline font-weight-bold accent--text">SECURITY</div>
                <div class="text-h5 font-weight-bold mb-1">Enter verification code</div>
                <div class="text-body-2 grey--text mb-6">
                    We've sent a 4-digit verification code to <strong>{{email}}</strong>. Enter it below to verify your email address.
                </div>

                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                    <v-row>
                        <v-col md="12" cols="12">
                            <v-text-field
                            v-model="code"
                            :counter="4"
                            :rules="numberRules"
                            label="Verification Code"
                            prepend-inner-icon="mdi-shield-key-outline"
                            outlined
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col md="12">
                            <v-btn
                            :disabled="!valid"
                            color="primary"
                            large
                            rounded
                            elevation="2"
                            class="font-weight-bold text-none mr-3"
                            @click="verify"
                            >
                            Verify
                            <v-icon right>mdi-check-circle-outline</v-icon>
                            </v-btn>
                            <v-btn
                            text
                            class="text-none"
                            @click="resend"
                            >
                            Resend Code
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderVue from '../../components/Header.vue'
import axios from 'axios';
  export default {
    name: 'VerifyEmail',
    components: {
        HeaderVue
    },
    data: () => ({
        code:null,
        email:sessionStorage.getItem('loggedUser') ? JSON.parse(sessionStorage.getItem('loggedUser')).email : null,
        valid: true,
        numberRules: [
            v => !!v || 'Verification Code is required',
            v => (v && v.length == 4) || 'Code must be 4 digits',
        ],
    }),
    methods: {
        verify () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.get(process.env.VUE_APP_AUTHURL+'/email/verify?email='+this.email+'&code='+this.code,
            {})
            .then((response) => {
                this.$toast.success('Email is now verified!', {
                    timeout: 5000
                });
                sessionStorage.loggedUser =   JSON.stringify(response.data.data)
                this.$store.commit("emailVerified", true);
                this.$router.push({name: 'Login'})
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        resend () {
            let loader = this.$loading.show()
            axios.get(process.env.VUE_APP_AUTHURL+'/email/verify/code?email='+this.email,
            {})
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
    },
  }
</script>

<style scoped>
.verify-page {
    min-height: calc(100vh - 64px);
}
.quick-links-panel {
    background: linear-gradient(180deg, #1E3C72 0%, #142A52 100%);
    min-height: 100%;
}
.recover-blurb {
    opacity: 0.85;
    max-width: 320px;
}
</style>
